import { initialGameState } from "../domain/reducer/reducer.js";
import type { GameState } from "../domain/types/index.js";
import { hasSave as defaultHasSave, loadGame as defaultLoadGame } from "../infrastructure/saveRepository.js";

type BootIO = {
  hasSave: () => boolean;
  loadGame: () => GameState | null;
};

export function readBootState(io: BootIO = { hasSave: defaultHasSave, loadGame: defaultLoadGame }): {
  state: GameState;
  loadError: string | null;
} {
  if (!io.hasSave()) return { state: initialGameState(), loadError: null };
  const loaded = io.loadGame();
  if (loaded) return { state: loaded, loadError: null };
  return {
    state: initialGameState(),
    loadError: "保存データを読み込めなかったため、新しいゲームとして開始できます。",
  };
}
